/**
 * One definition of the password rule.
 *
 * It had been stated in three places and disagreed with itself: the signup form
 * enforced 6 characters, Settings > Security enforced 8, and the reset flow did
 * not exist at all. A user could therefore create a 6-character password on
 * signup and then be told it was too short when changing it.
 *
 * 10 matches production Supabase Auth exactly, and matching is the point.
 *
 * It was 6 until 2026-09-30, because the server floor was 6 and a client rule
 * the server does not enforce is a claim, not a control: anyone calling the
 * Auth API directly would still get in at the lower number. The server moved
 * first — `GOTRUE_PASSWORD_MIN_LENGTH=10` and `GOTRUE_PASSWORD_HIBP_ENABLED=true`
 * on the self-hosted GoTrue, verified in production on 2026-09-29 — and this
 * followed. See docs/05-security/authentication-hardening.md.
 *
 * The breached-password (HIBP) check is server-only; there is nothing to mirror
 * here. The copy mentions it so the rejection is not a surprise.
 *
 * Change this ONLY together with the server setting — the server first, this
 * second — and re-verify both after any GoTrue upgrade.
 */
export const MIN_PASSWORD_LENGTH = 10;

export const describePasswordRule = (): string =>
    `Use at least ${MIN_PASSWORD_LENGTH} characters. Longer is better than complicated — a few unrelated words beats a short password with symbols in it. Passwords that have appeared in a known data breach are refused.`;

/** True when `password` satisfies the client-side rule. */
export const isAcceptablePassword = (password: string): boolean =>
    password.length >= MIN_PASSWORD_LENGTH;
